module.exports = __webpack_public_path__ + "media/images/escadotes/escadote_5-3c989abe6e6178dd958db55d8946f78f.png";